// frontend/src/utils/mobileLineDisplay.js
import { formatPhoneForDisplay } from './phoneUtils';

/**
 * A company SIM has two independent facts:
 * - who is accountable for it (the assigned staff record)
 * - whether the number reaches that person, or sits in a device
 *
 * Device lines stay assigned to a staff member for custody and offboarding.
 * They are not that person's Work Phone.
 */

const SIM_TAG = /^SIM-(\d{8})$/i;

/**
 * Readable SIM asset tag. The stored tag stays `SIM-80215439` so search,
 * QR, and letters keep one identifier. On screen the number uses the same
 * `XXXX XXXX` grouping as every other Singapore phone.
 *
 * Other asset tags are returned unchanged.
 *
 * @param {string|null|undefined} tag
 * @returns {string}
 */
export function formatAssetTagForDisplay(tag) {
  if (tag == null || tag === '') return '';
  const text = String(tag).trim();
  const match = text.match(SIM_TAG);
  if (!match) return text;
  return `SIM-${formatPhoneForDisplay(match[1])}`;
}

export const isDeviceMobileLine = (asset) => (
  asset?.register_holder_kind === 'equipment'
  || asset?.mobile_line?.holder_kind === 'equipment'
);

export const deviceLineContext = (asset) => {
  if (asset?.deployment_context) return asset.deployment_context;
  if (asset?.mobile_line?.holder_kind === 'equipment') {
    return asset.mobile_line.holder_label || '';
  }
  return '';
};

export const deviceLineLabel = (asset) => {
  const context = deviceLineContext(asset);
  return context ? `Device · ${context}` : 'Device';
};

/** Sheet text is a current holder only while the line is still deployed. */
export const showsRegisterHolder = (asset) => (
  Boolean(asset?.register_holder)
  && !asset?.current_assignee_name
  && asset?.status === 'deployed'
);
